export default "__VITE_ASSET__BS0KzjHe__"